import React from 'react'
import PropTypes from 'prop-types'
import './PatientHeader.css'
import withPolyglot from '../../../../common/withPolyglot'
import { getAgeDescription } from '../../../../../resources/utilities'

const PatientHeader = ({patientId, img, name, birthDate, formattedBirthDate, translate}) => {
  return (
    <div className='header-patient uk-grid'>
      <div className='patient-header-image uk-width-auto@s'>
        <span className='image'>
          {img
            ? <img className='patient-header-image-def' src={img} alt='' />
            : <span className='question' data-uk-icon='icon: question; ratio: 2.7' />
          }
        </span>
      </div>
      <div className='patient-header-name uk-width-expand@s'>
        <span>
          <strong>{translate('patient')}:</strong> {name}
          <div className='patient-header-age uk-width-auto@s'>
            <span className='age'>
              <strong>{translate('age')}:</strong> {`${getAgeDescription(birthDate, translate)} (${formattedBirthDate})`}
            </span>
          </div>
          <div className='patient-header-age uk-width-auto@s'>
            <span className='age'>
              <strong>Nº Utente:</strong> {patientId}
            </span>
          </div>
        </span>
      </div>
    </div>
  )
}
PatientHeader.propTypes = {
  patientId: PropTypes.string,
  img: PropTypes.string,
  name: PropTypes.string.isRequired,
  age: PropTypes.string
}
export default withPolyglot(PatientHeader, 'patientHeader')
